import http from '@/libs/http'
export function loadFeedBack (queryModel) {
  return http.get('crm/operate/listfeedback', { params: queryModel }).then((resp) => {
    if (resp.items && resp.items.length) {
      resp.items.forEach((item) => {
        if (item.images && item.images.split) {
          item.images = item.images.split(',')
        }
      })
    }
    return resp
  })
}

export function doAnswer (queryModel) {
  return http.put('api/operate/feedback/update', queryModel)
}

export function listCoupon (queryModel) {
  return http.get('crm/Operate/ListCoupon', { params: queryModel })
}

export const feedTypes = [
  {
    id: 1,
    name: '速度缓慢'
  },
  {
    id: 2,
    name: '缺少车型'
  },
  {
    id: 3,
    name: '数据有误'
  },
  {
    id: 4,
    name: '功能不合理'
  },
  {
    id: 5,
    name: '系统闪退'
  },
  {
    id: 6,
    name: '体验优化'
  }
]

export const couponStates = [
  {
    id: 1,
    name: '待领取'
  },
  {
    id: 2,
    name: '待使用'
  },
  {
    id: 3,
    name: '已使用'
  },
  {
    id: 4,
    name: '已失效'
  },
  {
    id: 5,
    name: '未领取'
  }
]
